// extracted by css-extract-rspack-plugin
export default {"ItemLink":"rTesG","SuggestionsSidebarWrapper":"NEZFO"};